import { createGlobalStyle } from 'styled-components'
import  { globalStyles } from 'twin.macro'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const GlobalStyles = createGlobalStyle(globalStyles, `
   /* Below animations are for modal created using React-Modal */
     .ReactModal__Overlay {
     transition: transform 300ms ease-in-out;
     transition-delay: 100ms;
     transform: scale(0);
   }
   .ReactModal__Overlay--after-open{
     transform: scale(1);
   }
   .ReactModal__Overlay--before-close{
     transform: scale(0);
   }

     .slider-container .slick-track {
  display: flex !important;
  justify-content: flex-start !important;
}


   .slick-prev:before, .slick-next:before{
   color:black;
   }
`)

export default GlobalStyles